// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"e0af250d","488":"08f76887","986":"d7399307"}[chunkId] + ".chunk.js";
};